import { useState, useRef } from 'react';
import STYLES from './Desktop.module.scss';
import Taskbar from './Taskbar';

import { desktopIconData, projectIconData } from '../../../images/imageData';
import projectData from '../../../data/projectData.json';

import DesktopIcon from './DesktopIcon';
import Window from './Window';

const Desktop = () => {
  const [windowOpen, setWindowOpen] = useState(false);
  const [activeProject, setActiveProject] = useState('');
  const desktopRef = useRef(null);

  const openWindow = (project) => {
    setWindowOpen(true);
    setActiveProject(project);
  };

  const closeWindow = () => {
    setWindowOpen(false);
    setActiveProject('');
  };

  const changeDesktopBackground = () => {
    const suitableHexCodes = [
      '#861313',
      '#b67c06',
      '#5bc507',
      '#870cb6',
      '#0c6fb6',
      '#b60c6f',
      '#3c0cb6',
      '#06b65e',
      '#b6067e',
      '#1b498d',
    ];
    const randomIndex = Math.floor(Math.random() * suitableHexCodes.length);
    desktopRef.current.style.backgroundColor = suitableHexCodes[randomIndex];
  };

  return (
    <div className={STYLES.Desktop} ref={desktopRef}>
      <div className={STYLES.Desktop__icons}>
        {Object.entries(projectData)
          .filter(([key, value]) => value.enabled === true)
          .map(([key]) => (
            <DesktopIcon
              key={key}
              label={key}
              altText={`${key} icon`}
              onClick={() => openWindow(key)}
            />
          ))}
      </div>
      <div className={STYLES.Desktop__iconsRight}>
        <DesktopIcon
          icon={desktopIconData.changeBG}
          label="Change Background"
          altText="Recycle Bin icon"
          onClick={() => changeDesktopBackground()}
        />
      </div>

      {windowOpen && (
        <Window
          project={projectData[activeProject]}
          onClose={() => closeWindow()}
        />
      )}

      <Taskbar />
    </div>
  );
};

export default Desktop;
